import React from 'react';
import { ArrowRight } from 'lucide-react';
interface CTAButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  children: ReactNode;
  fullWidth?: boolean;
  className?: string;
}
export function CTAButton({
  children,
  fullWidth = false,
  className = '',
  ...props
}: CTAButtonProps) {
  return <button className={`
        group relative overflow-hidden rounded-full bg-gradient-to-r from-rose-500 to-pink-600 
        px-8 py-4 font-bold text-white shadow-lg transition-all duration-300 
        hover:scale-105 hover:shadow-xl hover:from-rose-600 hover:to-pink-700
        focus:outline-none focus:ring-2 focus:ring-rose-400 focus:ring-offset-2
        active:scale-95
        ${fullWidth ? 'w-full' : 'w-auto'}
        ${className}
      `} {...props} data-id="element-213">
      <span className="relative flex items-center justify-center gap-2 text-lg" data-id="element-214">
        {children}
        <ArrowRight className="h-5 w-5 transition-transform group-hover:translate-x-1" data-id="element-215" />
      </span>
    </button>;
}